import type { ReactNode } from 'react';

interface IClientGoneProps {
  title: string;
  children: ReactNode;
  actions: ReactNode;
}

// An old run's link must land somewhere that says what happened, not on an error.
export const ClientGone = ({ title, children, actions }: IClientGoneProps) => (
  <section className="max-w-form rounded-card border border-border-raised bg-surface-raised p-card">
    <h1 className="text-page font-semibold tracking-page text-primary">{title}</h1>
    <p className="mt-2 text-data text-muted">{children}</p>
    <div className="mt-4 flex items-center gap-2">{actions}</div>
  </section>
);
